import { render, staticRenderFns } from "./ArticleSelectionList.vue?vue&type=template&id=5c01c680&scoped=true"
import script from "./ArticleSelectionList.vue?vue&type=script&lang=js"
export * from "./ArticleSelectionList.vue?vue&type=script&lang=js"
import style0 from "./ArticleSelectionList.vue?vue&type=style&index=0&id=5c01c680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c01c680",
  null
  
)

export default component.exports